/*
 * Developed by CQ Inversiones SAS.  Copyright (c) 2025. All rights reserved.
 * Desarrollado por CQ Inversiones SAS.  Copyright (c) 2025. Todos los derechos reservados.
 */

/*
 * Project:      mkad-frontend
 * Developed by: Juan David Pelaez Cumbe
 * Date:         28/04/25 - 18:27:07
 * Module name:  manage-session.interface
 * File name:    manage-session.interface.ts
 * IDE:          WebStorm
 */

export enum ManageTypeEnum {
  inactive,
  support,
  voyeur
}

export interface ManageSessionResponseInterface {
  customer_id: number;
  customer_level: number;
  customer_name: string;
  customer_initials: string;
  customer_enabled: boolean;
  allow_customers: boolean;
  allow_public_devs: boolean;
  user_level: number;
  manage_token: string;
  manage_type: ManageTypeEnum;
}

export interface VoyeurSessionDataInterface extends Omit<ManageSessionResponseInterface, 'manage_type'> {
  customer_name: string;
  manage_type: ManageTypeEnum.voyeur;
}
